export function handleStatusTextLogistic(orderStatus, occupationCycleStatus) {
  const removeAccents = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const normalizedOrderStatus = removeAccents(orderStatus).toUpperCase();
  const normalizedOccupationCycleStatus = occupationCycleStatus ? removeAccents(occupationCycleStatus).toUpperCase() : '';
  
  switch (normalizedOrderStatus) {
    case 'AGUARDANDO ANALISE DO FINANCEIRO':
      return 'Pedido recebido';
    case 'EM ANALISE PELO FINANCEIRO':
      return 'Em análise pelo financeiro';
    case 'AGUARDANDO APROVACAO DA LOGISTICA PARA INCLUSAO NA PROGRAMACAO':
    case 'AGUARDANDO APROVACAO DO CONSULTOR COMERCIAL PARA INCLUSAO NA PROGRAMACAO':
      return 'Em aprovação';
    case 'AGUARDANDO GERAR CHAVE PIX':
    case 'AGUARDANDO PAGAMENTO':
      return 'Aguardando pagamento';
    case 'PENDENTE DE PAGAMENTO DE DIVIDAS ANTERIORES':
      return 'Aguardando pagamento de débitos anteriores';
    case 'VALIDAR COMPROVANTE':
      return 'Em análise de comprovantes';
    case 'PENDENTE GERAR OU APROVAR PROTOCOLO':
    case 'PENDENTE CHECAR CREDITO':
      return 'Em análise de crédito';
    case 'NAO LIBERADO PELO FINANCEIRO':
      return 'Pedido com restrição financeira';
    case 'LIBERADO':
      if (normalizedOccupationCycleStatus && normalizedOccupationCycleStatus === 'NOTA FISCAL LIBERADA') {
        return 'Nota fiscal emitida';
      } else if (normalizedOccupationCycleStatus && normalizedOccupationCycleStatus === 'SAIDA DO VEICULO REALIZADA') {
        return 'Liberado para entrega ou retirada';
      } else if (normalizedOccupationCycleStatus && normalizedOccupationCycleStatus === 'EMITINDO NOTA FISCAL') {
          return 'Emitindo nota fiscal';
      } else {
        return 'Aguardando emissão de nota fiscal';
      }
    case 'RASCUNHO':
      return 'Pedido em rascunho';
    case 'EM VALIDACAO':
      return 'Pedido em processamento';
    default:
      return 'Pedido cancelado';
  }
}
